import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { RequestOptionsArgs, RequestOptions, ConnectionBackend, Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';

// Purpose of this class is to extend Http class in a manner that appends appropriate headers and
// access tokens to each http request. This class should only be used when request is for authenticated
// users. In case of requests like login and signup, use simple Http

@Injectable()
export class CustomHttp extends Http {
    private baseUrl: string = '';
    private headers: Headers;
    private customOptions: RequestOptions = new RequestOptions({ withCredentials: true });

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions, private _router: Router) {
        super(backend, defaultOptions);
        this.baseUrl = ''; //it can be very useful for other inherited components...
    }

    prepareForWegetAPI() {
        //Setting up Weget API Headers...
        if (!!localStorage.getItem('auth_token')) {
            this._defaultOptions.headers.set('Authorization', 'Bearer ' + localStorage.getItem('auth_token'));
        } else {
            this._defaultOptions.headers.delete('Authorization');
        }
        this._defaultOptions.headers.set('Content-Type', 'application/json;charset=utf-8');
        this._defaultOptions.headers.set('Accept', 'application/json, text/plain, */*');
        this._defaultOptions.headers.set('Access-Control-Allow-Credentials', 'true');
        this._defaultOptions.headers.set('Access-Control-Allow-Origin', '*');
    }

    setBaseUrl(url: string) {
        this.baseUrl = url;
    }

    get(url: string, options?: RequestOptionsArgs) {
        this.prepareForWegetAPI();
        
        return super.get(this.baseUrl + url, options).catch(err => this.handleError(err));
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<any> {
        this.prepareForWegetAPI();
        return super.post(this.baseUrl + url, body, this.customOptions).catch(err => this.handleError(err));
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<any> {
        this.prepareForWegetAPI();
        return super.put(this.baseUrl + url, body, this.customOptions).catch(err => this.handleError(err));
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<any> {
        this.prepareForWegetAPI();
        return super.delete(this.baseUrl + url, this.customOptions).catch(err => this.handleError(err));
    }

    handleError(err): Observable<Response> {
        if (err.status === 401) {
            localStorage.removeItem('auth_token');
            localStorage.removeItem('user_id');
            localStorage.removeItem('username');
            localStorage.removeItem('status');
            this._router.navigate(['/login']);
        }
        return Observable.throw(err);
    }
}



// WEBPACK FOOTER //
// ./src/directives/customhttp.ts